/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Judge_Call_CooldownInputs */



/**
* | output |
* | --- |
* | "Judge Called" |
*
* @param {Judge_Call_CooldownInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const judge_call_cooldown = /** @type {((inputs?: Judge_Call_CooldownInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Judge_Call_CooldownInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Arbitre appelé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Juez llamado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Juiz chamado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Giudice chiamato")
	return /** @type {LocalizedString} */ ("Judge Called")
});